import { Streamdown, defaultRehypePlugins } from 'streamdown'
import rehypeSlug from 'rehype-slug'
import 'streamdown/styles.css'
import { Card, CardContent } from '@/components/ui/card'

interface DraftBodyViewerProps {
  body: string
  /**
   * When true, injects rehype-slug into Streamdown's rehype pipeline so headings
   * receive stable `id` attributes (matching `github-slugger`'s output).
   * The article wrapper also receives `[&_h2]:scroll-mt-20` so anchor-link jumps
   * land below the sticky header. Default false — blog path is byte-identical.
   * @default false
   */
  enableHeadingIds?: boolean
  /**
   * When true, render the Era logo at the top of the draft. Used for PRD
   * drafts only — blog drafts opt out.
   * @default false
   */
  showLogo?: boolean
}

export function DraftBodyViewer({ body, enableHeadingIds = false, showLogo = false }: DraftBodyViewerProps) {
  const rehypePlugins = enableHeadingIds
    ? [...Object.values(defaultRehypePlugins), rehypeSlug]
    : undefined // blog path: inherit Streamdown defaults exactly

  return (
    <Card>
      <CardContent className="p-6">
        {showLogo && (
          <img
            src="https://era-public-bucket.s3.us-east-1.amazonaws.com/era-text-black.png"
            alt="Era"
            className="h-8 w-auto mb-4"
          />
        )}
        <article
          role="article"
          className={`prose prose-sm max-w-none${enableHeadingIds ? ' [&_h2]:scroll-mt-20' : ''}`}
        >
          <Streamdown rehypePlugins={rehypePlugins}>{body}</Streamdown>
        </article>
      </CardContent>
    </Card>
  )
}
